import StudentMark from "./StudentMark";

function App() {
  return <StudentMark />;
}

export default App;
